module.exports = __webpack_public_path__ + "img/arrow-bigger-white.30011fb3.svg";